import { API } from '../config'
import { AxiosResponse } from 'axios'
import { DeathsAndDiseasesDto, UpdateDeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'

const BASE_URL = 'entity/Morte'

export class DeathsAndDiseasesService {
  public async getDeathsAndDiseasesList(farmId: string): Promise<AxiosResponse<DeathsAndDiseasesDto[]>> {
    return await API.get(`${BASE_URL}/${farmId}`)
  }

  public async updateDeathsAndDiseases(
    farmId: string,
    deathsAndDiseasesDto: UpdateDeathsAndDiseasesDto
  ): Promise<AxiosResponse<DeathsAndDiseasesDto>> {
    return await API.put(`${BASE_URL}/${farmId}`, deathsAndDiseasesDto)
  }
}
